var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.293,7.707a1,1,0,0,1,0-1.414l4-4A1,1,0,0,1,7.707,3.707l-4,4a1,1,0,0,1-1.414,0Zm17.5,8.086-4,4a1,1,0,1,0,1.414,1.414l4-4a1,1,0,0,0-1.414-1.414Zm1.914-6.5a1,1,0,0,0-1.414,0l-11,11a1,1,0,1,0,1.414,1.414l11-11A1,1,0,0,0,21.707,9.293ZM3,15a1,1,0,0,0,.707-.293l11-11a1,1,0,1,0-1.414-1.414l-11,11A1,1,0,0,0,3,15Zm0,7a1,1,0,0,0,.707-.293l18-18a1,1,0,1,0-1.414-1.414l-18,18A1,1,0,0,0,3,22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateAnalytics);
export default __webpack_public_path__ + "static/media/empty-state-analytics.0c6d6e12e5d4091e5d58e9d63af9fe70.svg";
export { ForwardRef as ReactComponent };